import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b6b1a6b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search_form__footer" }
const _hoisted_2 = { class: "search_form__buttons" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        disabled: !_ctx.hasPrevious,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onPrevious && _ctx.onPrevious(...args))),
        class: "search_form__button"
      }, " Pergunta anterior ", 8, _hoisted_3),
      (_ctx.canFinish)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFinishForm && _ctx.onFinishForm(...args))),
            class: "search_form__button"
          }, " Finalizar formulário "))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        disabled: !_ctx.hasNext,
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onNext && _ctx.onNext(...args))),
        class: "search_form__button"
      }, " Próxima pergunta ", 8, _hoisted_4)
    ])
  ]))
}